var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResetSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.842,
    height: 78.842,
    viewBox: "0 0 78.842 78.842",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check-circle",
    "data-name": "Icon awesome-check-circle",
    d: "M79.4,39.983A39.421,39.421,0,1,1,39.983.562,39.421,39.421,0,0,1,79.4,39.983ZM35.424,60.856,64.671,31.609a2.543,2.543,0,0,0,0-3.6l-3.6-3.6a2.543,2.543,0,0,0-3.6,0L33.625,48.268,22.489,37.132a2.544,2.544,0,0,0-3.6,0l-3.6,3.6a2.543,2.543,0,0,0,0,3.6L31.827,60.856a2.543,2.543,0,0,0,3.6,0Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#40c100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetSuccess);
export default __webpack_public_path__ + "static/media/ResetSuccess.262689592a3c19344232e85d3b0248dd.svg";
export { ForwardRef as ReactComponent };